export default {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Produkte, Verkäufer, QC & Kaufleitfäden',
  navSpreadsheet: 'Spreadsheet',
  navCategories: 'Kategorien',
  navProducts: 'Produkte',
  navReviews: 'Bewertungen',
  navShipping: 'Versand',
  navCoupons: 'Gutscheine',
  navWarehouse: 'Lager',
  navQC: 'QC',
  navGuides: 'Leitfäden',
  navSafety: 'Sicherheit',
  navBlog: 'Blog',
  navAbout: 'Über',
  navContact: 'Kontakt',
  languageSelector: 'Sprache',
  ctaExplore: 'Spreadsheet Erkunden',
  ctaBuyNow: 'Jetzt Kaufen',
  ctaMainWebsite: 'Hauptwebsite Besuchen',
  ctaBrowseGuides: 'Leitfäden Durchsuchen',
  heroTitle: 'AllChinaBuy Spreadsheet',
  heroSubtitle: 'Produkte, Verkäufer & Kaufressourcen Schneller Finden',
  heroDescription: 'Entdecken Sie nützliche Produktlisten, Verkäuferressourcen, QC-Leitfäden, Versandinformationen und Kauftipps in einem organisierten AllChinaBuy-Hub.',
  trustLine: 'Aktualisierte Ressourcen • Praktische Leitfäden • Produktresearch • Kauf- und Versandinformationen',
  whatIsTitle: 'Was ist das AllChinaBuy Spreadsheet?',
  whatIsDesc: 'Das AllChinaBuy Spreadsheet ist ein bequemer Weg, Produktressourcen, Verkäuferinformationen, Kaufleitfäden und verwandte Recherchen zu organisieren und zu erkunden. Unser Ziel ist es, die Produktsuche und Kaufrecherche zu erleichtern, indem wir nützliche Ressourcen in einem durchsuchbaren Hub zusammenführen.',
  exploreResources: 'AllChinaBuy-Ressourcen Erkunden',
  popularCategories: 'Beliebte AllChinaBuy Spreadsheet Kategorien',
  latestGuides: 'Neueste AllChinaBuy Leitfäden',
  shippingCost: 'AllChinaBuy Versand & Kosten-Leitfäden',
  shippingCostDesc: 'Lernen Sie Versandmethoden, Kostenfaktoren, Lieferzeiten und praktische Recherchetipps für Ihre AllChinaBuy-Bestellungen kennen.',
  reviewTitle: 'AllChinaBuy Bewertung & Legitimitäts-Leitfaden',
  reviewDesc: 'Finden Sie neutrale Informationen über Plattformerfahrungen, Sicherheitsüberlegungen, Kontosicherheit, Zahlungsbewusstsein und wie Nutzer Informationen unabhängig verifizieren können.',
  compareTitle: 'Vergleichen Sie Vor Dem Kauf',
  compareDesc: 'Verwenden Sie Vergleichstabellen, um Verkäufer, Produkte, Versandoptionen, QC-Standards, Preise, Lager, Gutscheine und Kaufmethoden zu bewerten.',
  safetyTitle: 'Bleiben Sie Beim Einkaufen Sicher',
  safetyDesc: 'Lernen Sie essentielle Sicherheitstipps und Best Practices für Online-Shopping. Besuchen Sie unser Sicherheitszentrum für detaillierte Anleitungen.',
  finalCTATitle: 'Bereit, Das AllChinaBuy Spreadsheet Zu Erkunden?',
  finalCTADesc: 'Durchsuchen Sie unsere neuesten Spreadsheet-Ressourcen, Leitfäden, Vergleiche und Kaufinformationen.',
  footerRights: 'Alle Rechte vorbehalten.',
  footerDisclaimer: 'Diese Website ist ein unabhängiger Ressourcen-Hub. Alle Informationen dienen ausschließlich der Recherche.',
  footerLinks: 'Schnelle Links',
  footerResources: 'Ressourcen',
  footerLegal: 'Rechtliches',
  footerSitemap: 'Sitemap',
  footerPrivacy: 'Datenschutzrichtlinie',
  footerTerms: 'Nutzungsbedingungen',
  readMore: 'Mehr Lesen',
  updated: 'Aktualisiert',
  resourceSpreadsheet: 'AllChinaBuy Spreadsheet',
  resourceReviews: 'AllChinaBuy Bewertungen',
  resourceShipping: 'AllChinaBuy Versandkosten',
  resourceWarehouse: 'AllChinaBuy Lager',
  resourceCoupons: 'AllChinaBuy Gutscheine',
  resourceDiscounts: 'AllChinaBuy Rabattcodes',
  resourceLegit: 'AllChinaBuy Legit & Sicherheit',
  resourceQC: 'AllChinaBuy QC-Leitfäden',
  categoryClothing: 'Kleidung',
  categoryShoes: 'Schuhe',
  categoryAccessories: 'Accessoires',
  categoryElectronics: 'Elektronik',
  categoryBags: 'Taschen',
  categoryStreetwear: 'Streetwear',
  categoryHome: 'Home & Lifestyle',
  categoryPopular: 'Beliebte Funde',
  categorySellers: 'Vertrauenswürdige Verkäufer',
  categoryQC: 'QC-Ressourcen',
  aboutTitle: 'Über AllChinaBuy Spreadsheet',
  aboutDesc: 'Wir sind ein unabhängiger Ressourcen-Hub, der Käufern hilft, AllChinaBuy-Produktinformationen zu recherchieren und zu organisieren.',
  contactTitle: 'Kontaktieren Sie Uns',
  contactDesc: 'Haben Sie Fragen oder Vorschläge? Wir würden gerne von Ihnen hören.',
  safetyCenter: 'Sicherheitszentrum',
  safetyCenterDesc: 'Essentielle Sicherheitstipps und Best Practices für Online-Shopping und Recherche.',
  allchinabuySpreadsheet: 'AllChinaBuy spreadsheet',
  allchinabuyReview: 'AllChinaBuy review',
  allchinabuyShipping: 'AllChinaBuy shipping cost',
  allchinabuyCoupon: 'AllChinaBuy coupon',
  allchinabuyDiscount: 'AllChinaBuy discount code',
  allchinabuyWarehouse: 'AllChinaBuy warehouse',
  allchinabuyLegit: 'AllChinaBuy legit',
  allchinabuyQC: 'AllChinaBuy QC',
  allchinabuySellers: 'AllChinaBuy sellers',
  allchinabuyProducts: 'AllChinaBuy products',
  allchinabuyGuide: 'AllChinaBuy buying guide',
  breadcrumbHome: 'Startseite',
  breadcrumbBlog: 'Blog',
  breadcrumbAbout: 'Über',
  breadcrumbContact: 'Kontakt',
  breadcrumbSafety: 'Sicherheit',
  metaHomeTitle: 'AllChinaBuy Spreadsheet – Produkte, Verkäufer, QC & Kaufleitfäden',
  metaHomeDesc: 'Erkunden Sie das AllChinaBuy Spreadsheet mit Produktlisten, Verkäuferressourcen, QC-Leitfäden, Versandinformationen, Bewertungen, Gutscheinen und praktischen Kauftipps.',
  metaAboutTitle: 'Über AllChinaBuy Spreadsheet – Ressourcen-Hub',
  metaAboutDesc: 'Lernen Sie den AllChinaBuy Spreadsheet Ressourcen-Hub kennen. Unabhängige Research-Plattform für Produktsuche, Verkäuferbewertungen und Kaufleitfäden.',
  metaContactTitle: 'Kontaktieren Sie AllChinaBuy Spreadsheet – Bleiben Sie Verbunden',
  metaContactDesc: 'Kontaktieren Sie das AllChinaBuy Spreadsheet Team für Fragen, Vorschläge oder Ressourcenanfragen.',
  metaSafetyTitle: 'Sicherheitszentrum – AllChinaBuy Spreadsheet Shopping-Tipps',
  metaSafetyDesc: 'Bleiben Sie sicher bei der AllChinaBuy-Recherche. Lernen Sie Kontosicherheit, Zahlungsbewusstsein, Phishing-Prävention und sichere Browser-Praktiken.',
  metaArticleTitle: 'AllChinaBuy Spreadsheet Guide – Kaufressourcen & Tipps',
  metaArticleDesc: 'Detaillierte Leitfäden und Artikel über AllChinaBuy Spreadsheet Ressourcen, Kauftipps, Versandkosten und Verkäufer-Recherche.',
  relatedArticles: 'Verwandte Artikel',
  backToHome: 'Zurück zur Startseite',
  feature: 'Funktion',
  option: 'Option',
  bestFor: 'Beste Für',
  shippingMethod: 'Versandmethode',
  speed: 'Geschwindigkeit',
  cost: 'Kosten',
  tracking: 'Tracking',
  seller: 'Verkäufer',
  category: 'Kategorie',
  price: 'Preis',
  notes: 'Notizen',
  warehouse: 'Lager',
  function: 'Funktion',
  storage: 'Lagerung',
  qc: 'QC',
  lastModified: '2026-08-25',
  author: 'Redaktionsteam',
  published: 'Veröffentlicht',
  lastUpdated: 'Zuletzt Aktualisiert',
  tableOfContents: 'Inhaltsverzeichnis',
  quickAnswer: 'Kurze Antwort',
  detailedExplanation: 'Detaillierte Erklärung',
  practicalGuide: 'Praktischer Leitfaden',
  prosAndCons: 'Vorteile & Nachteile',
  commonMistakes: 'Häufige Fehler',
  safetyNotes: 'Sicherheitshinweise',
  faq: 'FAQ',
  ctaFunnel: 'Erkunden Sie weiter AllChinaBuy Ressourcen oder besuchen Sie unsere Hauptwebsite für mehr Produkte.',
  visitMain: 'Hauptwebsite Besuchen',
  spreadsheetGuide: 'Kompletter AllChinaBuy Spreadsheet Leitfaden',
  couponDesc: 'Entdecken Sie die neuesten AllChinaBuy-Gutscheine, Rabattcodes, Werbeaktionen und wie Sie sie anwenden, um bei Ihren Bestellungen zu sparen.',
  warehouseDesc: 'Verstehen Sie die AllChinaBuy-Lageroperationen, Lagerprozesse, QC-Verfahren und wie die Lagerverwaltung funktioniert.',
  qcDesc: 'Lernen Sie, QC-Fotos zu lesen, Produkte zu inspizieren, Qualitätsprobleme zu identifizieren und fundierte Entscheidungen vor dem Versand zu treffen.',
  spreadsheetGuideDesc: 'Ein umfassender Leitfaden zum Verstehen und Verwenden des AllChinaBuy Spreadsheet für Produktresearch und Kaufentscheidungen.',
  featuredProducts: 'Empfohlene Produkte',
  featuredProductsDesc: 'Durchsuchen Sie unsere kuratierte Auswahl beliebter Produkte aus dem AllChinaBuy Spreadsheet. Klicken Sie auf ein Element, um jetzt zu kaufen.',
  viewAllProducts: 'Alle Produkte Ansehen',
  buyNow: 'Jetzt Kaufen',
  productCatalog: 'Produktkatalog',
  productCatalogDesc: 'Durchsuchen Sie unsere kuratierte Auswahl an Produkten aus dem AllChinaBuy Spreadsheet. Klicken Sie auf einen Artikel, um direkt zu kaufen.',
  allProducts: 'Alle Produkte',
  items: 'Artikel',
  noProducts: 'Keine Produkte in dieser Kategorie.',
  lookingForMore: 'Suchen Sie Nach Mehr Produkten?',
  visitFullStore: 'Vollständigen Shop Besuchen',
  heroTrustUpdated: 'Aktualisierte Ressourcen',
  heroTrustPractical: 'Praktische Leitfäden',
  heroTrustResearch: 'Produktresearch',
  categoryBrowseDesc: 'Durchsuchen Sie Produktkategorien und erkunden Sie das AllChinaBuy Spreadsheet',
  showLess: 'Weniger Anzeigen',
  showAllCategories: 'Alle Kategorien Anzeigen',
  resourceCardDesc: 'Erkunden Sie Ressourcen und Leitfäden für',
  articlesDesc: 'Neueste Artikel über AllChinaBuy Spreadsheet, Kauftipps und Produktresearch',
  shippingDisclaimer: 'Überprüfen Sie aktuelle Informationen vor dem Kauf. Lieferzeiten und Kosten können variieren.',
  latestResources: 'Neueste Ressourcen',
  email: 'Email',
  responseTime: 'Antwortzeit',
  website: 'Website',
  sendMessage: 'Nachricht Senden',
  fillRequired: 'Bitte füllen Sie alle Pflichtfelder aus.',
  messageTooLong: 'Die Nachricht darf maximal 500 Zeichen lang sein.',
  thankYouMessage: 'Vielen Dank für Ihre Nachricht! Wir werden uns bald bei Ihnen melden.',
  safeBrowsingChecklist: 'Sichere Browser-Checkliste',
  verifyHTTPS: 'HTTPS Überprüfen',
  verifyHTTPSDesc: 'Überprüfen Sie immer das Schloss-Symbol und das HTTPS-Präfix, bevor Sie persönliche Informationen eingeben.',
  strongPasswords: 'Starke Passwörter Verwenden',
  strongPasswordsDesc: 'Erstellen Sie einzigartige Passwörter mit einer Mischung aus Buchstaben, Zahlen und Symbolen. Nutzen Sie einen Passwort-Manager.',
  twoFactorAuth: 'Zwei-Faktor-Authentifizierung Aktivieren',
  twoFactorAuthDesc: 'Fügen Sie eine zusätzliche Sicherheitsebene zu Ihren Konten hinzu, wenn die Plattform dies unterstützt.',
  researchBeforeBuy: 'Vor Dem Kauf Recherchieren',
  researchBeforeBuyDesc: 'Nehmen Sie sich Zeit, Verkäuferbewertungen zu lesen, Preise zu vergleichen und Produktdetails zu verifizieren, bevor Sie kaufen.',
  keepRecords: 'Unterlagen Aufbewahren',
  keepRecordsDesc: 'Speichern Sie Bestellbestätigungen, Trackingnummern und Kommunikation mit Verkäufern zur Referenz.',
  reportSuspicious: 'Verdächtige Aktivitäten Melden',
  reportSuspiciousDesc: 'Wenn Sie verdächtige Verkäufer, gefälschte Websites oder Phishing-Versuche begegnen, melden Sie diese umgehend.',
  safetyDisclaimer: 'Diese Sicherheitsinformationen dienen zu Bildungszwecken. Wir können die Sicherheit keiner Plattform, Verkäufers oder Transaktion garantieren.',
  pageNotFound: 'Seite Nicht Gefunden',
  pageNotFoundDesc: 'Die Seite, die Sie suchen, existiert nicht oder wurde verschoben.',
  productCardDesc: 'Erkunden Sie Ressourcen und Leitfäden für',
};